<template>
  <div class="contract">
    <el-form
      label-position="right"
      ref="form"
      size="small"
      :model="formData"
      :rules="rules"
      :disabled="disabled"
    >
      <el-form-item label-width="95px" label="所属年月" prop="reportDate">
        <el-date-picker
          v-model="formData.reportDate"
          type="month"
          placeholder="选择日期所属年月"
          style="width: 100%"
          format="yyyy-MM"
          value-format="yyyy-MM"
          clearable
        ></el-date-picker>
      </el-form-item>
      <el-form-item label-width="95px" label="财报" prop="financialReport">
        <el-input
          type="textarea"
          :autosize="{ minRows: 4, maxRows: 6 }"
          placeholder="请填写企业财报"
          v-model="formData.financialReport"
        ></el-input>
        <commonUpload
          @successUp="successUp"
          @removeUp="removeUp"
          :inputValue="'financialReportFileList'"
          :txt="'上传附件材料'"
          :list="formData.financialReportFileList"
        ></commonUpload>
      </el-form-item>
      <el-form-item label-width="95px" label="阶段性总结" prop="periodicSummary">
        <el-input
          type="textarea"
          :autosize="{ minRows: 4, maxRows: 6 }"
          placeholder=" 请填写企业阶段性总结"
          v-model="formData.periodicSummary"
        ></el-input>
        <commonUpload
          @successUp="successUp"
          @removeUp="removeUp"
          :inputValue="'periodicSummaryFileList'"
          :txt="'上传附件材料'"
          :list="formData.periodicSummaryFileList"
        ></commonUpload>
      </el-form-item>
      <el-form-item class="subBt" v-if="!disabled">
        <el-button type="primary" @click="onSubmit">提 交</el-button>
        <el-button @click="cancle">取 消</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import commonUpload from '@/components/common-upload.vue';
export default {
  props: ['dataList', 'disabled'],
  components: {
    commonUpload
  },
  data() {
    return {
      formData: {
        approvalStatus: 1,
        reportDate: null, // 所属年月
        financialReport: null, // 财报
        financialReportFileList: [], // 财报附件
        periodicSummary: null, // 阶段性总结
        periodicSummaryFileList: [] // 阶段性总结附件
      },
      rules: {
        reportDate: [
          {
            message: '请选择所属年月',
            required: true,
            trigger: 'change'
          }
        ],
        financialReport: [
          {
            required: true,
            message: '请输入财报',
            trigger: 'blur'
          }
        ],
        periodicSummary: [
          {
            required: true,
            message: '请输入阶段性总结',
            trigger: 'blur'
          }
        ]
      }
    };
  },
  created() {
    this.getFormData(this.dataList);
  },
  watch: {
    dataList(val) {
      this.getFormData(val);
    }
  },
  methods: {
    getFormData(data) {
      if (data) {
        data.financialReportFileList = this.getFileList(data.financialReportFileList);
        data.periodicSummaryFileList = this.getFileList(data.periodicSummaryFileList);
        this.formData = data;
      }
    },
    getFileList(strs) {
      if (strs && typeof strs === 'string') {
        return this.getFileList(JSON.parse(strs));
      } else if (strs) {
        return strs;
      }
      return [];
    },
    cancle() {
      this.$emit('cancle');
    },
    onSubmit() {
      this.$refs.form.validate(async valid => {
        if (valid) {
          this.$emit('onSubmit', this.formData);
        }
      });
    },
    //上传文件
    successUp(name, val) {
      this.formData[name] = this.getList(val);
    },
    removeUp(name, val) {
      console.log(name, val);
    },
    getList(fileList) {
      return fileList.map(el => {
        return {
          name: el.name,
          url: el?.url || el?.response?.data.store_result,
          uid: el.uid
        };
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.form {
  padding: 0 30px;
  .el-select,
  .el-date-editor,
  .el-cascader {
    width: 100%;
  }
}
</style>
